import styled from 'styled-components'
import { Heading2, BodyBold, BodySmall } from '@chegg-wt/core/theme/sunkist/typography'
import { Advert as OAdvert } from '../Advert'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Credibility',
})`
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  padding: 0px 15px;
`

export const Advert = styled(OAdvert)`
  text-align: center;
  padding: 15px;
`

export const Content = styled.div`
  max-width: 830px;
  margin: 24px auto;
`

export const Header = styled.h2`
  ${Heading2};
  padding: 16px;
`

export const ListHeader = styled.h2`
  ${BodyBold}
`

export const List = styled.ul``

interface BulletPointProps {
  tabbed?: boolean
}

export const BulletPoint = styled.li<BulletPointProps>`
  ${BodySmall};
  padding: 3px;
  margin-left: ${({ tabbed }) => (tabbed ? '25px' : '0px')};
  ::before {
    content: '•';
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
    display: inline-block;
    width: 1.5em;
  }
`

export const Paragraph = styled.p`
  ${BodySmall};
  padding: 3px;
`
